var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisplayOptions = function SvgDisplayOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 462",
    viewBox: "0 0 42.255 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.045 0h29.21v9.736h-29.21zM0 0h9.737v9.736H0zM2.334 15.6H17.14v14.8H2.334ZM0 32.737h19.473V13.264H0ZM25.115 15.6h14.8v14.8h-14.8Zm-2.333 17.14h19.473V13.264H22.782ZM0 36.263h42.255v9.736H0z"
  })));
};
export default SvgDisplayOptions;